import { useEffect } from 'react';
import { ActivationFunction, IOutputVectorParameters } from './output-vector-interfaces';
import { useOutputVectorStore } from './dal/output-vector-store';
import OutputVectorParameters from './ui/output-vector-parameters';
import OutputVectorView from './ui/output-vector-view';

const initialParameters: IOutputVectorParameters = {
    input: [
        ['1', 0],
        ['2', 1]
    ],
    connections: [
        ['1', '3', -2] ,
        ['1', '4', 4],
        ['2', '3', 3],
        ['2', '4', -1],
        ['3', '5', 1],
        ['4', '5', -1],
        ['3', '6', -1],
        ['4', '6', 1]
    ],
    activationFunction: ActivationFunction.hard_limit,
};

const OutputVectorHome = () => {

    const params = useOutputVectorStore(store => store.params);
    const setParams = useOutputVectorStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">Neural Network - Output Vector</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <OutputVectorParameters />
                        <OutputVectorView />
                    </div>
                }
            </div>

        </div>
    )
};

export default OutputVectorHome;
